import { Column, Row } from './experimental.grid';
import { ManagerReportTableState } from './tdcf-form.state';

export enum ColumnID {
    QUARTER,
    USER_ID,
    FIRST_NAME,
    LAST_NAME,
    STATUS,
    MANAGER_USER_ID,
    MANAGER_FIRST_NAME,
    MANAGER_LAST_NAME,
}

export class DataSource {
    thTpl: any; // TemplateRef
    tdTpl: any; // TemplateRef
    state: ManagerReportTableState;
    directTeamOnly: boolean;

    columns: Column[];
    headerRows: Row[];

    setData(): void {
        this.columns = [
            { id: ColumnID.QUARTER.toString(), width: null },
            { id: ColumnID.USER_ID.toString(), width: null },
            { id: ColumnID.FIRST_NAME.toString(), width: null },
            { id: ColumnID.LAST_NAME.toString(), width: null },
            { id: ColumnID.STATUS.toString(), width: null },
        ];

        this.headerRows = [
            {
                cells: [
                    { tpl: this.thTpl, columnId: ColumnID.QUARTER.toString() },
                    { tpl: this.thTpl, columnId: ColumnID.USER_ID.toString() },
                    {
                        tpl: this.thTpl,
                        columnId: ColumnID.FIRST_NAME.toString(),
                    },
                    {
                        tpl: this.thTpl,
                        columnId: ColumnID.LAST_NAME.toString(),
                    },
                    { tpl: this.thTpl, columnId: ColumnID.STATUS.toString() },
                ],
                id: null,
            },
        ];

        if (!this.directTeamOnly) {
            this.columns.splice(
                1,
                0,
                { id: ColumnID.MANAGER_USER_ID.toString(), width: null },
                { id: ColumnID.MANAGER_FIRST_NAME.toString(), width: null },
                { id: ColumnID.MANAGER_LAST_NAME.toString(), width: null },
            );

            this.headerRows[0].cells.splice(
                1,
                0,
                {
                    tpl: this.thTpl,
                    columnId: ColumnID.MANAGER_USER_ID.toString(),
                },
                {
                    tpl: this.thTpl,
                    columnId: ColumnID.MANAGER_FIRST_NAME.toString(),
                },
                {
                    tpl: this.thTpl,
                    columnId: ColumnID.MANAGER_LAST_NAME.toString(),
                },
            );
        }
    }

    makeRows(): Row[] {
        if (!this.state || !this.state.data) {
            return [];
        }
        return this.state.data.map((d) => {
            const cells = [
                {
                    tpl: this.tdTpl,
                    ctx: d,
                    columnId: ColumnID.QUARTER.toString(),
                },
                {
                    tpl: this.tdTpl,
                    ctx: d,
                    columnId: ColumnID.USER_ID.toString(),
                },
                {
                    tpl: this.tdTpl,
                    ctx: d,
                    columnId: ColumnID.FIRST_NAME.toString(),
                },
                {
                    tpl: this.tdTpl,
                    ctx: d,
                    columnId: ColumnID.LAST_NAME.toString(),
                },
                {
                    tpl: this.tdTpl,
                    ctx: d,
                    columnId: ColumnID.STATUS.toString(),
                },
            ];
            if (!this.directTeamOnly) {
                cells.splice(
                    1,
                    0,
                    {
                        tpl: this.tdTpl,
                        ctx: d,
                        columnId: ColumnID.MANAGER_USER_ID.toString(),
                    },
                    {
                        tpl: this.tdTpl,
                        ctx: d,
                        columnId: ColumnID.MANAGER_FIRST_NAME.toString(),
                    },
                    {
                        tpl: this.tdTpl,
                        ctx: d,
                        columnId: ColumnID.MANAGER_LAST_NAME.toString(),
                    },
                );
            }
            return {
                cells,
                id: null,
            };
        });
    }
}
